import React from "react";

interface JobDetails {
  dateOfSurvey: string;
  wellName: string;
}

interface GyroscopicSurveyHeaderProps {
  jobDetails: {
    dateOfSurvey: string; 
    wellName?: string;
  };
}

const GyroscopicSurveyHeader: React.FC<GyroscopicSurveyHeaderProps> = ({
  jobDetails,
}) => {
  const formattedDate = new Date(jobDetails.dateOfSurvey).toLocaleDateString("en-GB", {
    year: "numeric",
    month: "short",
    day: "2-digit",
  }).replace(/ /g, "-");
  
  const svgBackground = `url('data:image/svg+xml;utf8,<svg width="794.85" height="40" xmlns="http://www.w3.org/2000/svg"><polygon points="0,0 340,0 320,70 0,70" style="fill:%23DC1010;" /><polygon points="348,0 358,0 338,70 328,70" style="fill:%23DC1010;" /><polygon points="366,0 376,0 356,70 346,70" style="fill:%23DC1010;" /></svg>')`;

  return (
    <div
      className="w-full flex items-end justify-between font-sans relative"
      style={{
        height: "40px",
        backgroundImage: svgBackground,
        backgroundSize: "cover",
        backgroundRepeat: "no-repeat",
        paddingLeft: "5.03pt",
        paddingRight: "5.03pt",
      }}
    >
      {/* Left Title - Gyroscopic Survey Report */}
      <div className="flex items-center h-full z-10" style={{ width: "340px" }}>
        <p className="text-[16pt] font-semibold text-white m-0">
          Gyroscopic Survey Report
        </p>
      </div>

      {/* Date positioned in the middle space */}
     <div
  className="absolute z-0"
  style={{
    left: "70%", // slightly right from exact center
    transform: "translateX(-50%)",
  }}
>
        <p className="text-[11pt] text-gray-500 m-0 bg-white px-2 py-1 rounded">
          {formattedDate}
        </p>
      </div>

      {/* Right Section - RNS-40 with extended line */}
      <div className="flex items-center justify-end h-full z-10" style={{ width: "356px" }}>
        {/* Container for the line and text */}
        <div className="relative h-full flex items-center" style={{ width: "100%" }}>
          {/* Extended line that spans the entire right section */}
          <div 
            className="absolute bottom-0 left-0 h-[2px] bg-gray-500"
            style={{ width: "100%" }}
          />
          
          {/* RNS-40 text positioned at the end */}
          <div className="absolute right-0">
            <p className="text-[17pt] font-semibold text-[#DC1010] m-0">
              RNS-40
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default GyroscopicSurveyHeader;